import api from '../../api'
import { endpoints } from '../../apiCommons'
import localCompany from '../localStorage/localCompany'

const getFlag = async () => {
  const token = localStorage.getItem('token')
  const { sEmpresa } = localCompany.getUserData()
  return api.get(`${endpoints.empresaNuevoPortal}/${sEmpresa}`, {
    headers: { token },
  })
}

const updateFlag = async (bNuevoPortal) => {
  const token = localStorage.getItem('token')
  const { sEmpresa } = localCompany.getUserData()
  return api.put(
    `${endpoints.empresaNuevoPortal}/${sEmpresa}/${bNuevoPortal}`,
    {},
    { headers: { token } },
  )
}

export default {
  getFlag,
  updateFlag,
}
